<div class="margin-top-lg">
<mat-card-title class="h5">
	Address
	<span class="align-btn">

		<button *ngIf="!readOnly && editing" mat-raised-button color="primary" (click)="addRow()">
			Add Address
		</button>

	</span>
</mat-card-title>

<mat-accordion class="margin-top-lg">
	<mat-expansion-panel disabled="true" [expanded]="true" hideToggle="true">

		<table *ngIf="partyId>0 && kidsInfoByCoe && editing">
			<app-view-coe-child-info [partyId]="partyId" [CoeRelatedStudents]="CoeRelatedStudents"
				[spinner]="coeChildSpinner" (eventCoeStudents)="coeStudentsEventEmitter($event)">
			</app-view-coe-child-info>
		</table>
		<div class="">
			<mat-table [dataSource]="dataSource" *ngIf="dataSource.data.length>0"
				class="mat-elevation-z1 table-responsive">
				<div [matColumnDef]="col.key" *ngFor="let col of columnsSchema">
					<mat-header-cell *matHeaderCellDef [ngClass]="{'addressTypeWidth': col.key == 'addressType' }">
						<h4>{{ col.label }}</h4>
					</mat-header-cell>
					<mat-cell *matCellDef="let element" [ngClass]="{'past-row':  !determineEditRow(element)}">
						<div [ngSwitch]="col.key" *ngIf="!element.isEdit">
							<div *ngSwitchCase="'isEdit'" class="btn-edit">
								<div *ngIf="determineEditRow(element) && editing">
									<button *ngIf="!readOnly" mat-icon-button color="primary"
										(click)="editRow(element)">
										<mat-icon>edit</mat-icon>
									</button>
									<button *ngIf="!readOnly" mat-icon-button color="warn"
										(click)="RemoveCallCoeRelatedStudents(element)">
										<mat-icon>delete</mat-icon>
									</button>
								</div>
								<div *ngIf="!determineEditRow(element)" style="color:red">
									Past Address
								</div>
							</div>
							<span *ngSwitchCase="'activeDate'">
								{{ element.partyContactMechanisms?.CREATED_DATE | simpleDate }}
							</span>
							<span *ngSwitchCase="'addressType'">
								{{element.partyContactMechanisms?.PARTY_CONTACT_MECHANISM_PURPOSES ?
								element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE:
								''}}
							</span>
							<span *ngSwitchCase="'address'">
								{{element.partyContactMechanisms?.CONTACT_MECHANISMS ?
								element.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_1 : ''}}
								{{element.partyContactMechanisms?.CONTACT_MECHANISMS ?
								element.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_2 : ''}}
								{{element.partyContactMechanisms?.CONTACT_MECHANISMS ?
								element.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.CITY_NAME
								:
								''}}
								{{element.partyContactMechanisms?.CONTACT_MECHANISMS ?
								element.partyContactMechanisms?.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.STATE!.STATE_CODE
								+ ','
								: ''}}
								{{element.partyContactMechanisms?.CONTACT_MECHANISMS ?
								element.partyContactMechanisms?.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].POSTAL_CODES!.POSTAL_CODE
								:
								''}}
							</span>
						</div>

						<div [ngSwitch]="col.key" *ngIf="element.isEdit">
							<div *ngSwitchCase="'activeDate'">
								{{ element.partyContactMechanisms.CREATED_DATE | simpleDate }}
							</div>
							<div *ngSwitchCase="'addressType'">
								<div *ngIf="!element.isDelete">
									<mat-form-field class="form-input" style="width:100%" appearance="fill">
										<mat-label>Address Type</mat-label>
										<mat-select id="selContactMechanismPurposeTypes"
											name="selContactMechanismPurposeTypes"
											[ngModel]="element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES?.[0]?.CONTACT_MECHANISM_PURPOSE_TYPES"
											(ngModelChange)="element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES[0].CONTACT_MECHANISM_PURPOSE_TYPES = $event"
											[compareWith]="compareFn" required="true">
											<mat-option *ngFor="let type of contactMechanismPurposeTypes"
												[value]="type">
												{{type.TYPE}}
											</mat-option>
										</mat-select>

									</mat-form-field>
								</div>
								<div *ngIf="element.isDelete">
									{{element.partyContactMechanisms?.PARTY_CONTACT_MECHANISM_PURPOSES ?
									element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE:
									''}}
								</div>
							</div>

							<div *ngSwitchCase="'address'">
								<div *ngIf="!element.isDelete" class="row">
									<div class="col">
										<div class="row">

											<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
												<mat-form-field>
													<mat-label>Street Address</mat-label>
													<input matInput #input placeholder="Street Address 1"
														[(ngModel)]="element.partyContactMechanisms.CONTACT_MECHANISMS.POSTAL_ADDRESSES[0].STREET_1"
														required="true">
												</mat-form-field>
											</div>
											<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
												<mat-form-field>
													<mat-label>Street Address 2</mat-label>
													<input matInput #input placeholder="Street Address 2"
														[(ngModel)]="element.partyContactMechanisms.CONTACT_MECHANISMS.POSTAL_ADDRESSES![0].STREET_2">
												</mat-form-field>
											</div>

										</div>

										<div class="row">
											<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
												<input-city-autocomplete [id]="'City'" [name]="'City'" [label]="'City'"
													[placeholder]="'City'"
													[(selectedCity)]="element.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy"
													[(state)]="state" [required]="true">
												</input-city-autocomplete>
											</div>
											<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
												<input-state-autocomplete [id]="'State'" [name]="'State'"
													[label]="'State'" [placeholder]="'State'" [(selectedState)]="state"
													[required]="true">
												</input-state-autocomplete>
											</div>
											<div class="col-xs-12 col-sm-6 col-md-4 col-lg-12 col-xl-12">
												<input-zipcode-autocomplete [id]="'ZIP code'" [name]="'ZIP code'"
													[label]="'ZIP code'" [placeholder]="'ZIP code'"
													[(selectedZipcode)]="element.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].POSTAL_CODES"
													[required]="true" [countryId]="1">
												</input-zipcode-autocomplete>
											</div>
										</div>
									</div>


								</div>

								<div class="row" *ngIf="element.isDelete">
									<div class="col">
										{{element.partyContactMechanisms?.CONTACT_MECHANISMS ?
										element.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_1
										:
										''}}

										{{element.partyContactMechanisms?.CONTACT_MECHANISMS ?
										element.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_2
										:
										''}}
										{{element.partyContactMechanisms?.CONTACT_MECHANISMS ?
										element.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.CITY_NAME
										:
										''}}
										{{element.partyContactMechanisms?.CONTACT_MECHANISMS ?
										element.partyContactMechanisms?.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.STATE!.STATE_CODE
										+ ','
										: ''}}
										{{element.partyContactMechanisms?.CONTACT_MECHANISMS ?
										element.partyContactMechanisms?.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].POSTAL_CODES!.POSTAL_CODE
										:
										''}}
									</div>
								</div>
							</div>


							<div *ngSwitchCase="'isEdit'">
								<div *ngIf="!element.isDelete" class="row">
									<div class="col">
										<button mat-mini-fab color="primary" (click)="updateRow(element)"
											[disabled]="disableSubmit(element)">
											<mat-icon>done</mat-icon>
										</button>
									</div>
									<div class="col">
										<button mat-mini-fab (click)="cancelRow(element)">
											<mat-icon class="icon-display">cancel</mat-icon>
										</button>
									</div>
								</div>
								<div *ngIf="element.isDelete && !coeChildSpinner" class="row">
									<div class="col">
										<button mat-mini-fab color="primary" (click)="deleteRow(element)">
											<mat-icon>delete_forever</mat-icon>
										</button>
									</div>
									<div class="col">
										<button mat-mini-fab (click)="cancelRow(element)">
											<mat-icon class="icon-display">cancel</mat-icon>
										</button>
									</div>
								</div>
							</div>
						</div>
					</mat-cell>
				</div>
				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns"
					[ngClass]="{'past-row':  !determineEditRow(row)}"></mat-row>
			</mat-table>
		</div>
		<mat-paginator [length]="dataSource.data.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
			aria-label="Select page of periodic elements">
		</mat-paginator>
	</mat-expansion-panel>
</mat-accordion>
</div>
<!--<mat-accordion>
	<mat-expansion-panel>
		<mat-expansion-panel-header>
			<mat-panel-title class="danger">
				Past Address (es) ({{pastDataSource.data.length}})
			</mat-panel-title>
		</mat-expansion-panel-header>
		<table mat-table [dataSource]="pastDataSource">
			<ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchema">
				<th mat-header-cell *matHeaderCellDef [ngClass]="{'addressTypeWidth': col.key == 'addressType' }">
					<h4>{{ col.label }}</h4>
				</th>
				<td mat-cell *matCellDef="let element">
					<div [ngSwitch]="col.key">
						<span *ngSwitchCase="'activeDate'" style="padding-right: 10px;">
							{{ element.partyContactMechanisms?.CREATED_DATE | simpleDate }}
						</span>
						<span *ngSwitchCase="'addressType'">
							{{element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES ?
							element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE:
							''}}
						</span>
						<span *ngSwitchCase="'address'">
							{{element.partyContactMechanisms.CONTACT_MECHANISMS ?
							element.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_1 : ''}}
							{{element.partyContactMechanisms.CONTACT_MECHANISMS ?
							element.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_2 : ''}}
							{{element.partyContactMechanisms.CONTACT_MECHANISMS ?
							element.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.CITY_NAME :
							''}}
							{{element.partyContactMechanisms.CONTACT_MECHANISMS ?
							element.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.STATE!.STATE_CODE
							+ ','
							: ''}}
							{{element.partyContactMechanisms.CONTACT_MECHANISMS ?
							element.partyContactMechanisms.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].POSTAL_CODES!.POSTAL_CODE
							:
							''}}
						</span>
						<span *ngSwitchCase="'isEdit'">

						</span>

					</div>
				</td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
		</table>
	</mat-expansion-panel>
</mat-accordion>
-->